import CreateTypeForm from '../../Modals/DeviceModals/CreateTypeForm'
import CreateUserForm from '../../Modals/DeviceModals/CreateUserForm'
import CreateGroupFrom from '../../Modals/DeviceModals/CreateGroupFrom'
import CreateShadowForm from '../../Modals/DeviceModals/CreateShadowForm'
import AddCircuitModal from '../../Modals/CircuitModals/AddCircuitModal'
import CreateExperimentCategoryModal from '../../Modals/ExperimentModals/CreateExperimentCategoryModal'
import CreateExperimentTypeModal from '../../Modals/ExperimentModals/CreateExperimentTypeModal'
import AddAttributeModal from '../../Modals/AttributeModals/AddAttributeModal'
import CreateContentCategoryModal from '../../Modals/ContentModals/CreateContentCategoryModal'

function CreateTabContentModal({createProcess, item, setAction}: any) {
  if (createProcess === 'Type') {
    return <CreateTypeForm setAction={setAction} itemId={item.id} />
  } else if (createProcess === 'User') {
    return <CreateUserForm setAction={setAction} itemId={item.id} />
  } else if (createProcess === 'Group') {
    return <CreateGroupFrom setAction={setAction} itemId={item.id} />
  } else if (createProcess === 'Shadow') {
    return <CreateShadowForm itemId={item.id} setAction={setAction} />
  } else if (createProcess === 'Circuit') {
    return <AddCircuitModal itemId={item.id} setAction={setAction} />
  } else if (createProcess === 'ECategory') {
    return <CreateExperimentCategoryModal itemId={item.id} setAction={setAction} />
  } else if (createProcess === 'EType') {
    return <CreateExperimentTypeModal itemId={item.id} setAction={setAction} />
  } else if (createProcess === 'Attribute') {
    return <AddAttributeModal itemId={item.id} setAction={setAction} />
  } else if (createProcess === 'Category') {
    return <CreateContentCategoryModal itemId={item.id} setAction={setAction} />
  } /*  else if (createProcess === 'Message') {
    return (
      <CreateTopicMessageModal
        itemId={item.id}
        setAction={setAction}
     
      />
    )
  }*/
  return <div></div>
}

export default CreateTabContentModal
